export default __webpack_public_path__ + "static/media/1.5554b41c.png";